import React from 'react';
import classnames from 'classnames/bind';

import { NotificationRule } from 'types/notification_rule';

import { useNotificationRules } from 'settings/hooks/useNotificationRules';

import * as PageLayout from 'components/PageLayout';
import { Button } from 'components/Button/Button';
import { ExternalLink } from 'components/ExternalLink/ExternalLink';
import { Heading } from 'components/Heading/Heading';
import { Text } from 'components/Text/Text';

import { NotificationRuleForm } from './components/NotificationRuleForm';
import { NotificationRulesTable } from './components/NotificationRulesTable';
import styles from '../Members/Members.module.scss';

const c = classnames.bind(styles);

const PAGE_SIZE = 10;

export function NotificationRules() {
  const [page, setPage] = React.useState(1);
  const [isFormOpen, setIsFormOpen] = React.useState(false);
  const [editingRule, setEditingRule] = React.useState<NotificationRule>();

  const queryResult = useNotificationRules({
    params: { page, limit: PAGE_SIZE },
    keepPreviousData: true,
  });

  function handleCreate() {
    setEditingRule(undefined);
    setIsFormOpen(true);
  }

  const handleEdit = React.useCallback((rule: NotificationRule) => {
    setEditingRule(rule);
    setIsFormOpen(true);
  }, []);

  function handleFormClose() {
    setIsFormOpen(false);
    setEditingRule(undefined);
  }

  return (
    <PageLayout.Root size="medium">
      <PageLayout.Container>
        <div className={c('wrap')}>
          <div className={c('header')}>
            <div>
              <Heading level="2">Notification rules</Heading>
              <ExternalLink href="https://docs.lumeo.com/docs/notifications">
                Notifications docs
              </ExternalLink>
              <Text>
                Configure what operational alerts are sent and to whom.
              </Text>
            </div>

            <Button variant="secondary" size="small" onClick={handleCreate}>
              Create rule
            </Button>
          </div>

          <NotificationRulesTable
            queryResult={queryResult}
            pageSize={PAGE_SIZE}
            page={page}
            onPageChange={setPage}
            onEdit={handleEdit}
          />
        </div>

        <NotificationRuleForm
          open={isFormOpen}
          onClose={handleFormClose}
          rule={editingRule}
        />
      </PageLayout.Container>
    </PageLayout.Root>
  );
}
